import { render, staticRenderFns } from "./resumeState.vue?vue&type=template&id=fb0bb550&scoped=true"
import script from "./resumeState.vue?vue&type=script&lang=js"
export * from "./resumeState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0bb550",
  null
  
)

export default component.exports